import React, { useEffect, useMemo, useRef, useState } from "react";
import SEO from "../components/SEO";
import "./Home.css";
import heroVideo from "../assets/hero-video.mp4";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaBrain,
  FaUserGraduate,
  FaClock,
  FaSmile,
  FaStar,
  FaChevronLeft,
  FaChevronRight,
  FaWhatsapp,
  FaTimes,
} from "react-icons/fa";
import { FaSeedling, FaLeaf, FaTree, FaAward } from "react-icons/fa";

function CountUpStat({ end, suffix = "", duration = 2000 }) {
  const [count, setCount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.4 }
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let startTime = null;

    const animate = (time) => {
      if (!startTime) startTime = time;

      const progress = Math.min((time - startTime) / duration, 1);
      const value = Math.floor(progress * end);

      setCount(value);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(animate);
  }, [isVisible, end, duration]);

  return (
    <span ref={ref}>
      {count.toLocaleString("en-IN")}
      {suffix}
    </span>
  );
}

function Home() {
  const whatsappLink = "https://wa.me/919989284428";

  const testimonials = useMemo(
    () => [
      {
        name: "Aji Lal",
        role: "Parent Review",
        avatar: "A",
        text: "SIP Abacus is an excellent place for children to learn and grow. The teachers are very patient, friendly, and supportive. They make learning abacus fun and easy to understand. I have seen great improvement in speed, concentration, and overall confidence.",
        featured: true,
      },
      {
        name: "Anuradha Devarai",
        role: "Parent Review",
        avatar: "A",
        text: "After joining SIP Abacus my child improved a lot in solving problems, concentration, maths and memory power. It helped her in higher academics. I recommend everyone to join in SIP Abacus to improve their skills for achieving their goals.",
        featured: false,
      },
      {
        name: "Manisha 71095",
        role: "Parent Review",
        avatar: "M",
        text: "A great facility that provides students with quick and easy tips to solve math problems in minimal time. My niece has trained here and is doing really well now. My sister also got the opportunity to begin her teaching career here.",
        featured: false,
      },
      {
        name: "Sri Latha",
        role: "Parent Review",
        avatar: "S",
        text: "It is good and helps child to develop creativity, analysis, and visualization. Thanks to Sindhuja Ma'am for taking good care. Special thanks to Vanaja Ma'am and the entire staff.",
        featured: false,
      },
      {
        name: "Navya Shikari",
        role: "Parent Review",
        avatar: "N",
        text: "I am parent of G. S Aashritha. She is in advanced level 1. Abacus is very useful. My child improved a lot in mathematics and improved her confidence level in speed too. Thank you so much ma'am and team SIP Abacus.",
        featured: false,
      },
      {
        name: "Raju Mamidechtla",
        role: "Parent Review",
        avatar: "R",
        text: "I am father of Alankritha. Before joining Abacus she was unable to solve maths sums quickly. After joining Abacus she improved a lot in maths and academics. Thankful to her teachers and SIP Abacus team.",
        featured: false,
      },
    ],
    []
  );

  const [visibleCards, setVisibleCards] = useState(
    window.innerWidth <= 992 ? 1 : 2
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
  parentName: "",
  childName: "",
  phone: "",
  email: "",
  course: "",   // ✅ changed
  message: "",
});

  const [isTransitioning, setIsTransitioning] = useState(true);

  useEffect(() => {
  AOS.init({
    duration: 1000,
    once: true,
    easing: "ease-in-out",
    offset: 100,
    mirror: false,       // ← prevents re-trigger on scroll up
    anchorPlacement: "top-bottom",
  });
}, []);

  useEffect(() => {
    const handleResize = () => {
      const cardsToShow = window.innerWidth <= 992 ? 1 : 2;
      setVisibleCards(cardsToShow);
      setCurrentIndex(0);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const clonedTestimonials = [
    ...testimonials.slice(-visibleCards),
    ...testimonials,
    ...testimonials.slice(0, visibleCards),
  ];

  useEffect(() => {
    setCurrentIndex(visibleCards);
  }, [visibleCards]);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000);

    return () => clearInterval(interval);
  });

  const handleNext = () => {
    setCurrentIndex((prev) => prev + 1);
    setIsTransitioning(true);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => prev - 1);
    setIsTransitioning(true);
  };

  const handleTransitionEnd = () => {
    if (currentIndex >= testimonials.length + visibleCards) {
      setIsTransitioning(false);
      setCurrentIndex(visibleCards);
    }

    if (currentIndex === 0) {
      setIsTransitioning(false);
      setCurrentIndex(testimonials.length);
    }
  };

  useEffect(() => {
    if (!isTransitioning) {
      const id = setTimeout(() => {
        setIsTransitioning(true);
      }, 50);
      return () => clearTimeout(id);
    }
  }, [isTransitioning]);

  useEffect(() => {
    if (isFormOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isFormOpen]);

  const realIndex =
    ((currentIndex - visibleCards) % testimonials.length + testimonials.length) %
    testimonials.length;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFormSubmit = (e) => {
  e.preventDefault();

  const { parentName, childName, phone, email, course, message } = formData;

  const whatsappMessage = `
Hello, I would like to enquire about SIP Abacus.

Parent Name: ${parentName}
Child Name: ${childName}
Phone: ${phone}
Email: ${email}
Interested Course: ${course}

Message: ${message}
`;

  const encodedMessage = encodeURIComponent(whatsappMessage);

  const whatsappNumber = "919989284428"; // no +

  const url = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

  window.open(url, "_blank");

  // reset form
  setFormData({
    parentName: "",
    childName: "",
    phone: "",
    email: "",
    course: "",
    message: "",
  });

  setIsFormOpen(false);
};

  return (
    <>
      <SEO
        title="SIP Abacus Malkajgiri | Best Abacus Classes for Kids in Hyderabad"
        description="SIP Abacus Malkajgiri is a leading abacus learning institute in Malkajgiri, Hyderabad. We improve children's concentration, memory, speed, accuracy & confidence through scientifically designed mental arithmetic programs. Enroll your child today!"
        keywords="SIP Abacus, SIP Abacus Malkajgiri, abacus classes Malkajgiri, abacus classes Hyderabad, abacus training for kids, mental arithmetic classes, brain development for children, best abacus institute Hyderabad, abacus coaching near me, SIP Academy India, kids math improvement, concentration improvement classes, memory power training, speed math for kids, abacus learning centre Malkajgiri, after school programs Hyderabad, mental math training for children, abacus Secunderabad, abacus Bhavani Nagar Malkajgiri, children brain training Hyderabad, abacus demo class Hyderabad"
        canonicalPath="/"
      />
      <section className="home">
        <video className="hero-video" autoPlay muted loop playsInline>
          <source src={heroVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="hero-overlay"></div>

        <div className="container home-container">
          <div className="home-text" data-aos="fade-up">
            <h1>Welcome to SIP Abacus Malkajgiri</h1>
            <h2>Building strong brains with the power of Abacus learning</h2>
            <p>
              SIP Abacus Malkajgiri is a leading abacus learning institute focused on
              improving concentration, memory, speed, accuracy, and confidence
              in children through scientifically designed mental arithmetic
              programs.
            </p>
            <a href="/admission" className="home-btn">
              Join Now
            </a>
          </div>
        </div>
      </section>

      <section className="about">
        <div className="container">
          <div className="about-simple" data-aos="fade-up">
            <span className="about-tag">About us</span>

            <h2>Trusted learning excellence for young minds</h2>

            <p className="about-desc">
              SIP Abacus Malkajgiri has vast experience in developing skills among hundreds
              of thousands of children Internationally and across India.
              Originated from Malaysia in the year 1999 and SIP Abacus Malkajgiri was
              launched in India in the year 2010.
            </p>

            <div className="about-stats-simple">
              <div
                className="about-stat-item"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <h3>
                  <CountUpStat end={1000} suffix="+" />
                </h3>
                <p>Centres across 23 States in India</p>
              </div>

              <div
                className="about-stat-item"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <h3>
                  <CountUpStat end={1000000} />
                </h3>
                <p>Trained children since 1999</p>
              </div>

              <div
                className="about-stat-item"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <h3>
                  <CountUpStat end={11} />
                </h3>
                <p>Present in 11 Countries</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose">
        <div className="container">
          <div className="why-choose-header" data-aos="fade-up">
            <h2>Why Choose SIP Abacus Malkajgiri?</h2>
            <p>
              SIP Abacus Malkajgiri is a skill development programme that can help in
              various aspects of your child’s development. SIP Abacus courses
              are designed to develop soft skills, numerical abilities and
              overall intelligence.
            </p>
          </div>

          <div className="why-choose-grid">
            <div className="why-card" data-aos="fade-up" data-aos-delay="100">
              <div className="why-icon">
                <FaBrain />
              </div>
              <h3>Brain Development</h3>
              <p>
                Strengthens memory, concentration, visualization, and analytical
                thinking in children.
              </p>
            </div>

            <div className="why-card" data-aos="fade-up" data-aos-delay="200">
              <div className="why-icon">
                <FaUserGraduate />
              </div>
              <h3>Confidence Building</h3>
              <p>
                Helps children solve problems faster and perform better in both
                academics and daily activities.
              </p>
            </div>

            <div className="why-card" data-aos="fade-up" data-aos-delay="300">
              <div className="why-icon">
                <FaClock />
              </div>
              <h3>Speed & Accuracy</h3>
              <p>
                Improves calculation speed and accuracy through scientifically
                designed abacus techniques.
              </p>
            </div>

            <div className="why-card" data-aos="fade-up" data-aos-delay="400">
              <div className="why-icon">
                <FaSmile />
              </div>
              <h3>Fun Learning</h3>
              <p>
                Interactive teaching methods make learning enjoyable, engaging,
                and stress free for children.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="program-structure">
        <div className="container">
          <div className="program-structure-header" data-aos="fade-up">
            <span className="program-tag">Curriculum Overview</span>
            <h2>Well planned modules for every stage of growth</h2>
            <p>
              SIP Abacus is thoughtfully designed for children between{" "}
              <strong>6 and 12 years</strong> of age. Over time, the program has
              been continuously improved with stronger teaching practices,
              better learning methods, and a more refined curriculum experience.
            </p>
          </div>

          <div className="program-highlight" data-aos="zoom-in">
            <h3>
              Our Abacus journey is structured into four progressive learning
              levels.
            </h3>
          </div>

          <div className="module-icons">
            <div
              className="module-icon-item"
              data-aos="flip-up"
              data-aos-delay="100"
            >
              <div className="module-icon">
                <FaSeedling />
              </div>
              <h4>Junior Module</h4>
            </div>

            <div
              className="module-icon-item"
              data-aos="flip-up"
              data-aos-delay="200"
            >
              <div className="module-icon">
                <FaLeaf />
              </div>
              <h4>Foundation Module</h4>
            </div>

            <div
              className="module-icon-item"
              data-aos="flip-up"
              data-aos-delay="300"
            >
              <div className="module-icon">
                <FaTree />
              </div>
              <h4>Advanced Module</h4>
            </div>

            <div
              className="module-icon-item"
              data-aos="flip-up"
              data-aos-delay="400"
            >
              <div className="module-icon">
                <FaAward />
              </div>
              <h4>Grand Master Module</h4>
            </div>
          </div>

          <div className="program-features">
            <div
              className="program-feature-item"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <h5>Expert teachers</h5>
              <p>
                Our trainers go through structured evaluation and ongoing
                professional development.
              </p>
            </div>

            <div
              className="program-feature-item"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              <h5>Teacher advancement every year</h5>
              <p>
                Regular upskilling ensures children learn through current and
                effective teaching standards.
              </p>
            </div>

            <div
              className="program-feature-item"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <h5>Small batch learning</h5>
              <p>
                Limited class size allows more personal attention and better
                learning support for each child.
              </p>
            </div>

            <div
              className="program-feature-item"
              data-aos="fade-left"
              data-aos-delay="250"
            >
              <h5>Updated course framework</h5>
              <p>
                The curriculum is reviewed from time to time so it stays
                relevant, clear, and result oriented.
              </p>
            </div>

            <div
              className="program-feature-item"
              data-aos="fade-right"
              data-aos-delay="300"
            >
              <h5>Online and offline options</h5>
              <p>
                Students can learn comfortably through both classroom and
                digital modes.
              </p>
            </div>

            <div
              className="program-feature-item"
              data-aos="fade-left"
              data-aos-delay="350"
            >
              <h5>Competition opportunities</h5>
              <p>
                Children get exposure through regional, national, and
                international level competitive events.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <div className="container">
          <div className="testimonials-header" data-aos="fade-up">
            <h2>What Parents Say</h2>
            <p>
              Hear from parents who have seen remarkable improvement in their
              children’s confidence, concentration, and calculation skills.
            </p>
          </div>

          <div className="testimonial-carousel-wrapper" data-aos="fade-up">
            <button className="carousel-btn left" onClick={handlePrev}>
        <FaChevronLeft />
      </button>
            <div className="testimonial-viewport">
              <div
                className="testimonial-track"
                style={{
                  transform: `translateX(-${
                    currentIndex * (100 / visibleCards)
                  }%)`,
                  transition: isTransitioning ? "transform 0.5s ease" : "none",
                }}
                onTransitionEnd={handleTransitionEnd}
              >
                {clonedTestimonials.map((item, index) => (
                  <div className="testimonial-slide" key={index}>
                    <div
                      className={`testimonial-card ${
                        item.featured ? "featured" : ""
                      }`}
                    >
                      <div className="quote-mark">“</div>

                      <div className="testimonial-stars">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                      </div>

                      <p className="testimonial-text">{item.text}</p>

                      <div className="testimonial-footer">
                        <div className="testimonial-avatar">{item.avatar}</div>
                        <div>
                          <h4>{item.name}</h4>
                          <span>Google Review</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button className="carousel-btn right" onClick={handleNext}>
        <FaChevronRight />
      </button>
          </div>

          <div className="carousel-dots" data-aos="fade-up" data-aos-delay="150">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${realIndex === index ? "active" : ""}`}
                onClick={() => {
                  setCurrentIndex(index + visibleCards);
                  setIsTransitioning(true);
                }}
              />
            ))}
          </div>
        </div>
      </section>

      <div className="floating-actions" data-aos="zoom-in-left">
        <button
          className="enquiry-float-btn"
          onClick={() => setIsFormOpen(true)}
        >
          Enquiry Form
        </button>

        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-float-btn"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp />
        </a>
      </div>

      {isFormOpen && (
        <div
          className="enquiry-modal-overlay"
          onClick={() => setIsFormOpen(false)}
        >
          <div className="enquiry-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="enquiry-close-btn"
              onClick={() => setIsFormOpen(false)}
            >
              <FaTimes />
            </button>

            <h3>Enquiry Form</h3>
            <p>Fill in your details and we will get back to you soon.</p>

            <form className="enquiry-form" onSubmit={handleFormSubmit}>
              <input
                type="text"
                name="parentName"
                placeholder="Parent Name"
                value={formData.parentName}
                onChange={handleInputChange}
                required
              />

              <input
                type="text"
                name="childName"
                placeholder="Child Name"
                value={formData.childName}
                onChange={handleInputChange}
                required
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleInputChange}
              />

              <select
  name="course"
  value={formData.course}
  onChange={handleInputChange}
  required
>
  <option value="">Select a course</option>
  <option value="Abacus Beginner">Abacus Beginner / Junior</option>
  <option value="Abacus Advanced">Abacus Advanced</option>
  <option value="Foundation">Foundation</option>
  <option value="Grand Master">Grand Master</option>
  <option value="Demo Session">Demo Session</option>
</select>

              <textarea
                name="message"
                placeholder="Message"
                rows="4"
                value={formData.message}
                onChange={handleInputChange}
              ></textarea>

              <button type="submit" className="enquiry-submit-btn">
                Submit Enquiry
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default Home;